import Divider from '@mui/material/Divider';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import {
  CATEGORY_ID,
  SUBCATEGORY_ID
} from '@/features/TicketCreateDialog/TicketCreateDialog.constants';

import {
  ServiceFormChangeRequestInternalNetworks,
  ServiceFormChangeRequestTravelNotification
} from './ServiceFormChangeRequest';
import ServiceFormLogRestoreExport from './ServiceFormLogRestoreExport';

const ServiceFormExtended = () => {
  const { control, unregister } = useFormContext();

  const [ticketCategory, ticketSubcategory] = useWatch({
    control,
    name: ['ticket_category', 'ticket_subcategory']
  });

  const IS_ENVIRONMENTS_CHANGE_REQUEST_TICKET =
    ticketCategory === CATEGORY_ID.CHANGE_REQUEST &&
    ticketSubcategory === SUBCATEGORY_ID.INTERNAL_NETWORKS;

  const IS_LOG_RESTORE_EXPORT_TICKET =
    ticketCategory === CATEGORY_ID.LOG_RESTORE_EXPORT;

  //-----------------------------------------------------------------
  // unregister (remove) custom_data if ticket does not include custom_data fields
  useEffect(() => {
    if (
      ticketCategory !== 0 ||
      ticketSubcategory !== null ||
      !IS_ENVIRONMENTS_CHANGE_REQUEST_TICKET ||
      !IS_LOG_RESTORE_EXPORT_TICKET
    ) {
      unregister('custom_data');
    }
  }, [ticketCategory, ticketSubcategory]);

  return (
    <>
      {/**
       * category: Change Request
       * sub-category: Internal Networks
       */}
      {ticketCategory === CATEGORY_ID.CHANGE_REQUEST &&
        ticketSubcategory === SUBCATEGORY_ID.INTERNAL_NETWORKS && (
          <>
            <Divider />
            <ServiceFormChangeRequestInternalNetworks />
          </>
        )}
      {/**
       * category: Change Request
       * sub-category: Travel Notification
       */}
      {ticketCategory === CATEGORY_ID.CHANGE_REQUEST &&
        ticketSubcategory === SUBCATEGORY_ID.TRAVEL_NOTIFICATION && (
          <>
            <Divider />
            <ServiceFormChangeRequestTravelNotification />
          </>
        )}
      {/**
       * category: Log Restore/Export
       */}
      {ticketCategory === CATEGORY_ID.LOG_RESTORE_EXPORT && (
        <>
          <Divider />
          <ServiceFormLogRestoreExport />
        </>
      )}
    </>
  );
};

export default ServiceFormExtended;
